import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/context/auth-context'
import { ThemeProvider } from '@/context/theme-context'
import { AnnouncementModalProvider } from '@/context/announcement-context'
import { Toaster } from '@/components/ui/toaster'

import LandingPage from '@/pages/LandingPage'
import LoginPage from '@/pages/LoginPage'
import RegisterPage from '@/pages/RegisterPage'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import DashboardPage from '@/pages/DashboardPage'
import RecordsPage from '@/pages/RecordsPage'
import AddRecordPage from '@/pages/AddRecordPage'
import PricingPage from '@/pages/PricingPage'
import AboutPage from '@/pages/AboutPage'
import SettingsPage from '@/pages/SettingsPage'
import InstitutionSignupPage from '@/pages/InstitutionSignupPage'
import AppLayout from '@/components/layouts/AppLayout'

// Provider pages
import ProviderPatientsPage from '@/pages/provider/ProviderPatientsPage'
import ProviderRecordsPage from '@/pages/provider/ProviderRecordsPage'
import ProviderAnalyticsPage from '@/pages/provider/ProviderAnalyticsPage'
import StaffManagementPage from '@/pages/provider/StaffManagementPage'
import ProvidersPage from '@/pages/ProvidersPage'

import ProtectedRoute from '@/components/auth/ProtectedRoute'
import { ThemeDemo } from '@/components/ui/theme-demo'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="min-h-screen bg-background transition-colors duration-300">
          <Routes>
            {/* Root route */}
            <Route path="/" element={<LandingPage />} />

            {/* Landing page */}
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/providers" element={<ProvidersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/institution-signup" element={<InstitutionSignupPage />} />

            {/* Theme demo route for testing */}
            <Route path="/theme-demo" element={<ThemeDemo />} />

            {/* Auth routes - standalone */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Protected app routes */}
            <Route path="/app" element={
              <ProtectedRoute>
                <AnnouncementModalProvider>
                  <AppLayout />
                </AnnouncementModalProvider>
              </ProtectedRoute>
            }>
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="records" element={<RecordsPage />} />
              <Route path="add-record" element={<AddRecordPage />} />

              {/* Provider-specific routes */}
              <Route path="provider/staff" element={<StaffManagementPage />} />
              <Route path="patients" element={<ProviderPatientsPage />} />
              <Route path="patients/search" element={<ProviderPatientsPage />} />
              <Route path="shared-records" element={<ProviderRecordsPage />} />
              <Route path="analytics" element={<ProviderAnalyticsPage />} />
              <Route path="analytics/patients" element={<ProviderAnalyticsPage />} />
              <Route path="analytics/usage" element={<ProviderAnalyticsPage />} />
              <Route path="settings" element={<SettingsPage />} />

              <Route index element={<Navigate to="dashboard" replace />} />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <Toaster />
        </div>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App